import cx from 'clsx'
import React, { DetailedHTMLProps, LiHTMLAttributes } from 'react'

import cn from '../styles.module.scss'

export interface IListItemProps
  extends DetailedHTMLProps<LiHTMLAttributes<HTMLLIElement>, HTMLLIElement> {
  color?: 'black' | 'white' | 'gradient'
  weight?: 'normal' | 'medium' | 'bold'
  opacity?: number
  size?: 'h1' | 'h2' | 'h3' | 'big' | 'small'
}

const ListItem = ({
  color = 'black',
  weight = 'normal',
  opacity = 1,
  size = 'small',
  style,
  className,
  children,
  ...rest
}: IListItemProps) => {
  const classes = cx(cn.listItem, cn[color], cn[weight], cn[size], className)
  return (
    <li {...rest} className={classes} style={{ opacity, ...style }}>
      {children}
    </li>
  )
}

export default ListItem
